import toggleLeaderBoard from '../../js/leaderboard.js'
import toggleInfoBox from '../../js/infobox'

export default class CSSLayer
{
    constructor() 
    {
        this.blockPinchZoom()

        window.toggleLeaderBoard = toggleLeaderBoard;
        window.toggleInfoBox = toggleInfoBox;
        window.infoboxTimeout = null

        window.addEventListener("DOMContentLoaded", () => {
            this.getLeaderBoard();
            
            //Disabling default 
            // window.infoboxTimeout = setTimeout(() => {
            //     toggleInfoBox()
            // }, 5000);

            // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);

            // We listen to the resize event
            window.addEventListener('resize', () => {
                // We execute the same script as before
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            });

            // document.querySelector(".leaderboard-button").addEventListener("click", () => {
            //     toggleLeaderBoard()
            // })
            document.querySelector(".infobox-button").addEventListener("click", () => {
                toggleInfoBox()
            })
        
            const map = (value, x1, y1, x2, y2) => (value - x1) * (y2 - x2) / (y1 - x1) + x2;
            // Increment Values ToggleBox
            setInterval(() => {
                let now = new Date();
        
                // create an object using the current day/month/year
                let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                
                let projectStart = new Date(2022, 7, 15);
        
                let diff = now - today; // ms difference
                const dailyVolume = map(Math.round(diff / 10), 0, 8640000, 0, 200);
        
                let projectDiff = now - projectStart; // ms difference
                let projectDiffDays = projectDiff/1000/60/60/24;
                
                const totalDataValue = 80 + map(projectDiffDays, 0, 135, 0, 40);
        
                // document.getElementById("infobox_concurrent_queries").innerHTML = concurrentValue;
                document.getElementById("infobox_data_volume").innerHTML = totalDataValue.toFixed(3) + "TB";
                document.getElementById("infobox_daily_volume").innerHTML = dailyVolume.toFixed(3) + "M";
            }, 500);
        
        
            setInterval (() => {
                let now = new Date();
                let projectStart = new Date(2022, 7, 15);
        
                let projectDiff = now - projectStart; // ms difference
                let projectDiffDays = Math.round(projectDiff / 1000 / 60 / 60 / 24);
        
                const concurrentValue = 4000 + (projectDiffDays * 100) + Math.round((Math.random() * 25 - 12.5));
                document.getElementById("infobox_concurrent_queries").innerHTML = concurrentValue;
            }, 2000)
        })
        
        // Check Click Outside Clicks
        window.addEventListener("mousedown", (event) => {
            const infobox = document.querySelector(".infobox");
            const leaderboardContainer = document.querySelector(".leaderboard-container");
            const leaderboard = document.querySelector(".leaderboard");
      
            if (event.clientX < infobox.getBoundingClientRect().left || event.clientY < infobox.getBoundingClientRect().top) 
            {
                toggleInfoBox(true);
            }

            // console.log(event.clientX, ">", leaderboard.getBoundingClientRect().right, " | ", event.clientY, "<", leaderboard.getBoundingClientRect().top)
            if (
                event.clientX > leaderboard.getBoundingClientRect().right || event.clientY < leaderboard.getBoundingClientRect().top || 
                (event.clientY > leaderboard.getBoundingClientRect().bottom && event.clientX > window.innerWidth/2)
            ) {
                toggleLeaderBoard(true);
            }
        })
    }
  
    // Get Data from JSON Leaderboard
    getLeaderBoard() {
        let leaderboard_data = null;
        fetch('https://www.mecha.studio/sxt/assets/leaderboard.json')
            .then((response) => response.json())
            .then((data) => {
                leaderboard_data = data;
                
                let leaderboardTemplate = "";
                for (const entry of leaderboard_data) {
                    let roll = entry.title.length > 30 ? "roll-anim" : "";
                    entry.title = entry.title.length > 30 ? "<span>" + entry.title + "</span>" + "<span> " + entry.title + "</span> " : entry.title;
    
                    leaderboardTemplate += `
                    <div class="leaderboard-entry">
                        <h3 class="leaderboard-entry-title t-inter ${roll}">${entry.title}</h3>
                        <div class="leaderboard-entry-values t-jetbrainsmono">
                            <div class="value">
                                <div class="icon-edit"></div>
                                <span>${entry.author}</span>
                            </div>
                            <div class="value">
                                <div class="icon-clock"></div>
                                <span>${entry.date}</span>
                            </div>
                            <div class="value">
                                <div class="icon-views"></div>
                                <span>${entry.views}</span>
                            </div>
                        </div>
                    </div>`;
                }
    
                // Set Data to Leaderboard
                document.querySelector(".leaderboard-list").innerHTML = leaderboardTemplate;
            });
    }

    blockPinchZoom() {
        document.querySelector(".leaderboard-container").addEventListener("touchstart", (event) =>
        {
            if(event.touches.length > 1){
                //the event is multi-touch
                //you can then prevent the behavior
                event.preventDefault()
            }
        }, false);

        document.querySelector(".infobox").addEventListener("touchstart", (event) =>
        {
            if(event.touches.length > 1){
                //the event is multi-touch
                //you can then prevent the behavior
                event.preventDefault()
            }
        }, false);
    }
}